import BusinessSupportMenu from '../Components/Support/BusinessSupportMenu';

function BusinessSupportPage() {
  return <BusinessSupportMenu />;
}

export default BusinessSupportPage;